import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f50dcde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PRDetail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "PRDetail_Header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "PRDetail_HeaderTitle" })
], -1))
const _hoisted_3 = { class: "PRDetail_Main" }
const _hoisted_4 = { class: "PRDetail_TableContainer" }
const _hoisted_5 = { class: "PRDetail_Table PRDetail_DisplayPC" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "検索キーワード"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
  /*#__PURE__*/_createElementVNode("th", null, "発売日"),
  /*#__PURE__*/_createElementVNode("th", null, "シリーズ名"),
  /*#__PURE__*/_createElementVNode("th", null, "取置在庫数"),
  /*#__PURE__*/_createElementVNode("th", null, "断裁"),
  /*#__PURE__*/_createElementVNode("th", null, "ケース")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌CD"),
  /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
  /*#__PURE__*/_createElementVNode("th", null, "著者名"),
  /*#__PURE__*/_createElementVNode("th", null, "出荷可能数"),
  /*#__PURE__*/_createElementVNode("th", null, "当日受注入力数"),
  /*#__PURE__*/_createElementVNode("th", null, "スリップ"),
  /*#__PURE__*/_createElementVNode("th", null, "帯")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "書誌名"),
  /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
  /*#__PURE__*/_createElementVNode("th", null, "カテゴリ"),
  /*#__PURE__*/_createElementVNode("th", null, "返品"),
  /*#__PURE__*/_createElementVNode("th", null, "保留合計"),
  /*#__PURE__*/_createElementVNode("th", null, "カバー"),
  /*#__PURE__*/_createElementVNode("th", null, "最新印数")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<table class=\"PRDetail_Table PRDetail_DisplayTB\" data-v-1f50dcde><tr data-v-1f50dcde><th data-v-1f50dcde>検索キーワード</th><th data-v-1f50dcde>書誌名</th><th data-v-1f50dcde>ISBN13桁</th><th data-v-1f50dcde>発売日</th><th data-v-1f50dcde>カテゴリ</th><th data-v-1f50dcde>出荷可能数</th><th data-v-1f50dcde>取置在庫数</th><th data-v-1f50dcde>保留合計</th><th data-v-1f50dcde>スリップ</th><th data-v-1f50dcde>ケース</th><th data-v-1f50dcde>最新印数</th></tr><tr data-v-1f50dcde><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td></tr><tr data-v-1f50dcde><th data-v-1f50dcde>書誌CD</th><th data-v-1f50dcde>ISBN13桁</th><th data-v-1f50dcde>本体価格</th><th data-v-1f50dcde>著者名</th><th data-v-1f50dcde>シリーズ名</th><th data-v-1f50dcde>返品</th><th data-v-1f50dcde>当日受注入力数</th><th data-v-1f50dcde>断裁</th><th data-v-1f50dcde>カバー</th><th data-v-1f50dcde>帯</th></tr><tr data-v-1f50dcde><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td></tr></table><table class=\"PRDetail_Table PRDetail_DisplayMulti\" data-v-1f50dcde><tr data-v-1f50dcde><th data-v-1f50dcde>改装出退予定日</th><th data-v-1f50dcde>重版出来予定日</th><th data-v-1f50dcde>備考</th><th data-v-1f50dcde>現在在庫ST</th><th data-v-1f50dcde>VAN強制ST<br data-v-1f50dcde>運用期間From</th></tr><tr data-v-1f50dcde><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td></tr><tr data-v-1f50dcde><th data-v-1f50dcde>改装出退予定数</th><th data-v-1f50dcde>重版出来予定数</th><th data-v-1f50dcde>備考表示期限</th><th data-v-1f50dcde>VAN強制ST</th><th data-v-1f50dcde>VAN強制ST<br data-v-1f50dcde>運用期間To</th></tr><tr data-v-1f50dcde><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td></tr></table><table class=\"PRDetail_Table PRDetail_DisplaySP\" data-v-1f50dcde><tr data-v-1f50dcde><th data-v-1f50dcde>検索キーワード</th><th data-v-1f50dcde>書誌CD</th><th data-v-1f50dcde>書誌名</th><th data-v-1f50dcde>ISBN13桁</th><th data-v-1f50dcde>ISBN13桁</th><th data-v-1f50dcde>本体価格</th><th data-v-1f50dcde>発売日</th><th data-v-1f50dcde>著者名</th><th data-v-1f50dcde>カテゴリ</th><th data-v-1f50dcde>シリーズ名</th><th data-v-1f50dcde>出荷可能数</th><th data-v-1f50dcde>返品</th><th data-v-1f50dcde>取置在庫数</th><th data-v-1f50dcde>当日受注入力数</th><th data-v-1f50dcde>保留合計</th><th data-v-1f50dcde>断裁</th><th data-v-1f50dcde>スリップ</th><th data-v-1f50dcde>カバー</th><th data-v-1f50dcde>ケース</th><th data-v-1f50dcde>帯</th><th data-v-1f50dcde>最新印数</th><th data-v-1f50dcde>改装出退予定日</th><th data-v-1f50dcde>改装出退予定数</th><th data-v-1f50dcde>重版出来予定日</th><th data-v-1f50dcde>重版出来予定数</th><th data-v-1f50dcde>備考</th><th data-v-1f50dcde>備考表示期限</th><th data-v-1f50dcde>現在在庫ST</th><th data-v-1f50dcde>VAN強制ST</th><th data-v-1f50dcde>VAN強制ST<br data-v-1f50dcde>運用期間From</th><th data-v-1f50dcde>VAN強制ST<br data-v-1f50dcde>運用期間To</th></tr><tr data-v-1f50dcde><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td><td data-v-1f50dcde></td></tr></table>", 3)

import { computed } from "vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductReferenceDetail',
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const route = useRoute();
const emit = __emit;

// let modalVisible = ref<boolean>(false);
// let modalVisible_memo = ref<boolean>(false);
// let modalVisible_van = ref<boolean>(false);
// let isActive_KaniFlg = ref<boolean>(false);
// let isActive_SyosaiFlg = ref<boolean>(false);
// let searchAreaToggle = ref<boolean>(true);
// let isActiveSelectAll = ref<boolean>(false);
// let selectedProduct = null;
let search_result = [
  {
    id: 1,
    syosi_cd: 92847520398,
    syosi_isbn: 4987232984795,
    syosi_mei: "私の推しが今日も最高に尊いので、全力で幸せに",
    ryohin: 840,
    henpin: 7,
    kakaku: 1200,
    num: 0,
    syosi_janCd: 422987934,
    torioki: 0,
    series_title: "アイリスNEO",
    bikou: "",
    category: "330:ノベル",
    zaiko: 11,
    kyouseiST: "",
    release_date: "2022/02/02",
    cyosya: "仙月:作",
    selectFlg: false,
  },
  {
    id: 2,
    syosi_cd: 92847520398,
    syosi_isbn: 4987232984795,
    syosi_mei: "踊り場にスカートが鳴る",
    ryohin: 840,
    henpin: 7,
    kakaku: 1200,
    num: 0,
    syosi_janCd: 422987934,
    torioki: 0,
    series_title: "アイリスNEO",
    bikou: "",
    category: "330:ノベル",
    zaiko: 11,
    kyouseiST: "",
    release_date: "2022/02/02",
    cyosya: "仙月:作",
    selectFlg: false,
  },
  {
    id: 3,
    syosi_cd: 92847520398,
    syosi_isbn: 4987232984795,
    syosi_mei: "ふたりエスケープ",
    ryohin: 840,
    henpin: 7,
    kakaku: 1200,
    num: 0,
    syosi_janCd: 422987934,
    torioki: 0,
    series_title: "アイリスNEO",
    bikou: "",
    category: "330:ノベル",
    zaiko: 11,
    kyouseiST: "",
    release_date: "2022/02/02",
    cyosya: "仙月:作",
    selectFlg: false,
  },
  {
    id: 4,
    syosi_cd: 92847520398,
    syosi_isbn: 4987232984795,
    syosi_mei: "私の推しは悪役令嬢。",
    ryohin: 840,
    henpin: 7,
    kakaku: 1200,
    num: 0,
    syosi_janCd: 422987934,
    torioki: 0,
    series_title: "アイリスNEO",
    bikou: "",
    category: "330:ノベル",
    zaiko: 11,
    kyouseiST: "",
    release_date: "2022/02/02",
    cyosya: "仙月:作",
    selectFlg: false,
  },
];

// const openReferencePopUp = (): void => {
emit("toggleGlobalHeader");
// };
const selectedResult = computed(() => {
  return search_result[Number(route.params.id) - 1];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(selectedResult.value.syosi_cd), 1),
            _createElementVNode("td", null, _toDisplayString(selectedResult.value.release_date), 1),
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12,
            _hoisted_13
          ]),
          _hoisted_14,
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, _toDisplayString(selectedResult.value.syosi_mei), 1),
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _hoisted_18,
            _hoisted_19,
            _hoisted_20
          ])
        ]),
        _hoisted_21
      ])
    ])
  ]))
}
}

})